<template>
  <div class="elite-content" v-bind:class="[isActive ? 'unfold' : 'fold']">
    <notifications></notifications>
    <div
      class="elite-content_sidebar"
      :class="{ 'has-level2': $route.meta.hasLevel2 }"
      ref="sidebar"
    >
      <div
        class="elite-content_sidebar_level1"
        v-bind:class="[
          isActive ? 'unfold' : 'fold',
          shouldFold ? 'shouldFold' : ' ',
        ]"
      >
        <div class="elite-content_sidebar_level1_logo">
          <router-link :to="{ name: 'Dashboard' }">
            <span class="logo">
              <img src="/img/elixio-connect.svg" alt="logo" />
            </span>
            <span class="logo-icon">
              <img src="/img/connect-icon.svg" alt="logo-icon" />
            </span>
          </router-link>
          <button @click="toggleClass()">
            <svg
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.87049 2.703H11.1288C11.8631 2.703 12.4551 2.703 12.9348 2.74229C13.4286 2.78294 13.8621 2.86762 14.2632 3.0722C14.9005 3.39692 15.4186 3.91506 15.7433 4.55236C15.9479 4.95339 16.0333 5.38762 16.0732 5.88078C16.1125 6.36039 16.1125 6.95246 16.1125 7.68678V9.91278C16.1125 10.6471 16.1125 11.2392 16.0732 11.7188C16.0326 12.2126 15.9479 12.6462 15.7433 13.0472C15.4186 13.6845 14.9005 14.2026 14.2632 14.5274C13.8621 14.7319 13.4286 14.8173 12.9348 14.8573C12.4545 14.8966 11.8631 14.8966 11.1288 14.8966H6.87049C6.13617 14.8966 5.54411 14.8966 5.06449 14.8573C4.57133 14.8166 4.13711 14.7319 3.73675 14.5274C3.0992 14.2027 2.58082 13.6846 2.25591 13.0472C2.05133 12.6462 1.96598 12.2126 1.92601 11.7188C1.88672 11.2385 1.88672 10.6471 1.88672 9.91278V7.68678C1.88672 6.95246 1.88672 6.36039 1.92601 5.88078C1.96665 5.38762 2.05133 4.95339 2.25591 4.55304C2.58041 3.91524 3.09857 3.3966 3.73607 3.07152C4.13711 2.86694 4.57133 2.78158 5.06449 2.74162C5.54478 2.703 6.13617 2.703 6.87049 2.703ZM5.17491 4.09239C4.76507 4.12626 4.52933 4.18858 4.35117 4.27936C3.96879 4.47419 3.65791 4.78508 3.46307 5.16745C3.3723 5.34562 3.30998 5.58136 3.27611 5.9912C3.24223 6.40916 3.24156 6.94636 3.24156 7.71591V9.88365C3.24156 10.6539 3.24156 11.1904 3.27611 11.6084C3.30998 12.0182 3.3723 12.2539 3.46307 12.4321C3.65791 12.8145 3.96879 13.1254 4.35117 13.3202C4.52933 13.411 4.76507 13.4733 5.17491 13.5072C5.59288 13.541 6.13007 13.5417 6.89962 13.5417H7.30607V4.05784H6.89962C6.1294 4.05784 5.59288 4.05784 5.17491 4.09239ZM8.66091 4.05784V13.5417H11.0996C11.8698 13.5417 12.4064 13.5417 12.8243 13.5072C13.2342 13.4733 13.4699 13.411 13.6481 13.3202C14.0304 13.1254 14.3413 12.8145 14.5362 12.4321C14.6269 12.2539 14.6893 12.0182 14.7231 11.6084C14.757 11.1904 14.7577 10.6532 14.7577 9.88365V7.71591C14.7577 6.94568 14.7577 6.40916 14.7231 5.9912C14.6893 5.58136 14.6269 5.34562 14.5362 5.16745C14.3413 4.78508 14.0304 4.47419 13.6481 4.27936C13.4699 4.18858 13.2342 4.12626 12.8243 4.09239C12.4064 4.05852 11.8692 4.05784 11.0996 4.05784H8.66091ZM4.25769 6.42881C4.25769 6.24915 4.32906 6.07684 4.4561 5.9498C4.58314 5.82276 4.75544 5.75139 4.93511 5.75139H5.61253C5.79219 5.75139 5.96449 5.82276 6.09153 5.9498C6.21857 6.07684 6.28994 6.24915 6.28994 6.42881C6.28994 6.60847 6.21857 6.78078 6.09153 6.90782C5.96449 7.03486 5.79219 7.10623 5.61253 7.10623H4.93511C4.75544 7.10623 4.58314 7.03486 4.4561 6.90782C4.32906 6.78078 4.25769 6.60847 4.25769 6.42881ZM4.25769 8.79978C4.25769 8.62011 4.32906 8.44781 4.4561 8.32077C4.58314 8.19373 4.75544 8.12236 4.93511 8.12236H5.61253C5.79219 8.12236 5.96449 8.19373 6.09153 8.32077C6.21857 8.44781 6.28994 8.62011 6.28994 8.79978C6.28994 8.97944 6.21857 9.15174 6.09153 9.27878C5.96449 9.40583 5.79219 9.4772 5.61253 9.4772H4.93511C4.75544 9.4772 4.58314 9.40583 4.4561 9.27878C4.32906 9.15174 4.25769 8.97944 4.25769 8.79978Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div class="elite-content_sidebar_level1_menu">
          <main-navbar-apps></main-navbar-apps>
        </div>
        <div class="elite-content_sidebar_level1_user">
          <div class="elite-content_sidebar_level1_user_avatar">
            <div class="elite-content_sidebar_level1_user_avatar_image">
              <base-dropdown
                v-if="me"
                title-classes="btn dropdown-button"
                menu-on-top
                :has-toggle="false"
              >
                <template slot="title">
                  <div class="user-dropdown">
                    <span>
                      {{ `${me.firstname.charAt(0)}${me.lastname.charAt(0)}` }}
                    </span>
                    <img
                      v-if="me.profile_image"
                      :src="me.profile_image"
                      alt="profile-picture"
                    />
                    <img v-else src="/img/vpt-logo.svg" alt="profile-picture" />
                  </div>
                </template>
                <li>
                  <router-link to="/me" v-if="me">
                    <i class="fal fa-user"></i>
                    <span>{{ `${me.firstname + " " + me.lastname}` }}</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/me?tab=locations" v-if="me">
                    <i class="ni ni-map-big"></i>
                    <span>
                      {{ $t("COMMON.MY_LOCATIONS") }}
                    </span>
                  </router-link>
                </li>
                <li>
                  <button @click="logout">
                    <i class="fal fa-sign-out"></i>{{ $t("COMMON.LOGOUT") }}
                  </button>
                </li>
              </base-dropdown>
            </div>
          </div>
          <div class="elite-content_sidebar_level1_user_lang">
            <div class="elite-content_sidebar_level1_user_lang_selected">
              <base-dropdown
                title-classes="btn btn-sm btn-neutral mr-0"
                menu-on-left
                :has-toggle="false"
                menuClasses="lang-switcher"
              >
                <template slot="title">
                  <img
                    ref="lang"
                    :src="`/img/locale_flags/${$i18n.locale}.svg`"
                    :alt="$i18n.locale"
                    @click="getPosition"
                  />
                </template>
                <li v-for="lang in languages" :key="lang">
                  <a
                    class="dropdown-item"
                    v-bind:class="{ active: lang === $i18n.locale }"
                    @click="selectLang(lang)"
                  >
                    <img :src="`/img/locale_flags/${lang}.svg`" :alt="lang" />
                    <span>{{ lang }}</span>
                    <i class="fal fa-check"></i>
                  </a>
                </li>
              </base-dropdown>
            </div>
          </div>
          <div class="elite-content_sidebar_level1_user_menu">
            <ul>
              <li class="notifications">
                <router-link to="/notifications" v-if="me">
                  <span class="notifications_wrapper">
                    <notifications-count />
                  </span>
                  <i class="far fa-bell"></i>
                </router-link>
              </li>
              <li>
                <a href="#"><i class="far fa-envelope"></i></a>
              </li>
              <li>
                <a href="#"><i class="far fa-question-circle"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <router-view name="SidebarSecondLevelMenu"></router-view>
    </div>
    <div
      class="elite-content_body"
      :style="{ width: `calc( 100% - ${width}px)`, marginLeft: width + 'px' }"
    >
      <div class="elite-content_body_inner">
        <router-view></router-view>
      </div>
    </div>
    <div class="elite-content_bot">
      <button>
        <i class="fal fa-comments"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapGetters } from "vuex";
import { loadLanguageAsync } from "@/plugins/i18n";
import MainNavbarApps from "./partials/MainNavbarApps.vue";
import NotificationsCount from "./partials/NotificationsCount.vue";

export default {
  components: { MainNavbarApps, NotificationsCount },

  mixins: [],

  data() {
    return {
      isActive: false,
      languages: ["fr", "en"],
      width: null,
      observer: null,
      positionTop: 0,
      positionLeft: 0,
      shouldFold: false,
    };
  },

  methods: {
    toggleClass(event) {
      if (this.isActive) {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
    },

    selectLang(lang) {
      loadLanguageAsync(lang);
    },

    sidebarObserver() {
      const box = this.$refs.sidebar,
        vm = this,
        config = {
          attributes: true,
          childList: true,
        };
      const elementToObserve = document.querySelector(".elite-content_sidebar");
      const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          vm.width = entry.contentRect.width;
        });
      });
      observer.observe(elementToObserve, config);
      this.observer = observer;
    },

    getPosition() {
      this.positionTop = this.$refs["lang"].getBoundingClientRect().top;
      this.positionLeft = this.$refs["lang"].getBoundingClientRect().left;
      const dropdown = document.querySelector(".lang-switcher");
      if (this.isActive === false) {
        dropdown.style.cssText = `
          top: ${this.positionTop - 40}px;
          left: ${this.positionLeft}px;
        `;
      } else {
        dropdown.style.cssText = `bottom: 0; left: 0;`;
      }
    },

    menuLinkClickHandler() {
      this.shouldFold = true;
      setTimeout(
        function () {
          this.shouldFold = false;
        }.bind(this),
        1000
      );
    },

    menuHoverObserver() {
      const firstMenuLinks = document.querySelectorAll(
        ".elite-content_sidebar_level1_menu_wrapper > ul > li > a"
      );
      for (const menuLink of firstMenuLinks) {
        menuLink.removeEventListener("click", this.menuLinkClickHandler);
      }
      for (const menuLink of firstMenuLinks) {
        menuLink.addEventListener("click", this.menuLinkClickHandler);
      }
    },

    logout() {
      try {
        this.$store.dispatch("logout");
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, something went wrong!",
        });
      }
    },
  },

  async mounted() {
    this.sidebarObserver();
  },

  computed: {
    ...mapGetters("profile", { me: "me" }),
  },

  watch: {
    me: {
      handler: debounce(function (val) {
        this.menuHoverObserver();
      }),
      deep: true,
    },
  },
};
</script>
